import { Button } from "../components/ui/button";
import { UserContext } from "../contexts/UserContext";
import {RedirectToSignup, useAuthInfo, useLogoutFunction} from "@propelauth/react";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ProfileIcon } from "../components/ui/icons/ProfileIcon";
import NotificationHeader from "../components/notification/NotificationHeader";
import { ProjectBreadCrumb } from "./ProjectBreadCrumb";
import { AlertTriangle } from "lucide-react";

export default function SiteHeader() {
    const userContext = useContext(UserContext);
    const logoutFn = useLogoutFunction();

    const { accessToken } = useAuthInfo();

    return (
        <header className="sticky top-0 z-20 w-full bg-[#fcfafa] bg-card text-card-foreground shadow">
            <div className="container mx-auto flex items-center h-16 px-4">
                <div className="flex-1 flex  h-full justify-start md:pr-1 lg:pr-20">
                    <div className="text-left xl:relative xl:right-4 ">
                       <img src="/wordmark.svg" alt="C-Street Logo" className="h-full w-[80%] block object-contain lg:mr-5"/>
                    </div> 
                    <div className="h-full md-lg:flex items-end hidden ">
                    <ProjectBreadCrumb/>

                    </div>
                </div>
                <div className="flex items-center ml-auto">
                    <Link
                        to="/company"
                        className="flex items-center text-xs mr-7 text-gray-400 hover:text-black"
                    >
                        <ProfileIcon className="w-7 h-7 mr-2" />
                        <div className="flex flex-col">
                            <span className="text-xs text-black">
                                {userContext?.email}
                            </span>
                            <span className="text-xs text-gray-400 flex items-center gap-1">
                                {/*{userContext?.is_claimed === false && (*/}
                                {/*    <AlertTriangle className="w-3.5 h-3.5 text-amber-500" />*/}
                                {/*)}*/}
                                {userContext?.company_name}
                            </span>
                        </div>
                    </Link>
                    <NotificationHeader accessToken={accessToken!} />
                    <Button
                        variant="secondary"
                        className="text-sm text-primary hover:text-secondary"
                        onClick={() => logoutFn(true)}
                    >
                        Log Out
                    </Button>
                </div>
            </div>
        </header>
    );
}


export  function AnonymousHeader() {


    return (
        <header className="sticky top-0 z-20 w-full bg-[#fcfafa] bg-card text-card-foreground shadow">
            <div className="container mx-auto flex items-center h-16 px-4">
                <div className="flex-1 flex  h-full justify-start md:pr-1 lg:pr-20">
                    <div className="text-left xl:relative xl:right-4 ">
                       <img src="/wordmark.svg" alt="C-Street Logo" className="h-full w-[80%] block object-contain lg:mr-5"/>
                    </div>
                    <div className="h-full md-lg:flex items-end hidden ">

                    </div>
                </div>
                <div className="flex items-center ml-auto">
                    <Link
                        to="/company"
                        className="flex items-center text-xs mr-7 text-gray-400 hover:text-black"
                    >

                        <div className="flex flex-col">
                            <span className="text-xs text-black">

                            </span>

                        </div>
                    </Link>

                </div>
            </div>
        </header>
    );
}
